import { type FC } from 'react'

import AutocompleteResult, { type AutocompleteResultModel } from '../atoms/AutocompleteResult'

import { type AutocompleteBaseProps } from './Autocomplete.types'
import GenericAutocomplete, { type GenericAutocompleteProps } from './GenericAutocomplete'

export type AutocompleteProps = AutocompleteBaseProps<AutocompleteResultModel> &
  Pick<GenericAutocompleteProps<AutocompleteResultModel>, 'recalculateMaxHeightAfterDelayInMs'>

const Autocomplete: FC<AutocompleteProps> = ({ autocompleteRef, children, ...props }) => (
  <GenericAutocomplete AutocompleteItemComponent={AutocompleteResult} {...props} ref={autocompleteRef}>
    {children}
  </GenericAutocomplete>
)

export default Autocomplete
